const cadastro_de_transporte_escolar_por_turma = [
  {
    path: "/cadastro-de-transporte-escolar-por-turma",
    redirect: "/cadastro-de-transporte-escolar-por-turma",
    meta: {
      breadCrumb: "Gestão - Informação Complementar do Aluno",
    },
    children: [
      {
        path: "/cadastro-de-transporte-escolar-por-turma",
        name: "cadastro_de_transporte_escolar_por_turma",
        component: () =>
          import(
            "@/views/CadastroDeTransporteEscolarPorTurma/CadastroDeTransporteEscolarPorTurma.vue"
          ),
      },
      {
        path: "/cadastro-de-transporte-escolar-por-turma/:turma_id/:escola_id/:ano_matricula",
        name: "cadastro_de_transporte_escolar_por_turma_novo",
        component: () =>
          import(
            "@/views/CadastroDeTransporteEscolarPorTurma/CadastroDeTransporteEscolarPorTurmaNovo.vue"
          ),
      },
    ],
  },
];

export { cadastro_de_transporte_escolar_por_turma };
